import slug from 'slug';
import moment from 'moment/moment';
import { displayTime } from './timeConvertorHelper';
import { createBranchIOLink } from './branchIOHelper';

const MINUTE = 60;
const HOUR = MINUTE * 60;

export function toJSON(data) {
    if (typeof data === 'object') {
        return JSON.stringify(data);
    } else {
        throw new Error('should be an object');
    }
}

export function getCurrentWindowWidth() {
    let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth;

    return x;
}

export function toFormData(requestData) {
    const formData = new FormData();

    for (let key in requestData) {
        if (Array.isArray(requestData[key])) {
            requestData[key].forEach(phone => formData.append(`${key}[]`, phone));
        } else {
            formData.append(`${key}`, requestData[key]);
        }
    }

    return formData;
}

export const path = function getPath(obj, ...props) {
    const value = obj[props[0]];
    if (props.length === 1 || !value) {
        return value;
    }
    const rest = props.slice(1);

    return getPath.apply(null, [value, ...rest]);
};

export function isEmptyObject(obj) {
    if (typeof obj === 'object') {
        return Object.keys(obj).length === 0;
    } else {
        throw new Error('The argument should be a type of objeect');
    }
}

export function isObjectType(obj) {
    const type = Object.prototype.toString.call(obj).slice(8, -1);

    if (type.toLowerCase() === 'object') return true;
    return false;
}

export const convertBooleansToNumbers = data => {
    Object.keys(data).map(key => {
        if (typeof data[key] === 'boolean') {
            if (data[key] === true) data[key] = 1;
            else data[key] = 0;
        }
    });

    return data;
};

export function filterThoughtFields(maxValue) {
    return function validateThought(values, ...restOfNotRequiredFIeld) {
        let fieldedInputs = 0;
        for (let key in values) {
            if (values.hasOwnProperty(key)) {
                if (!restOfNotRequiredFIeld.includes(key)) {
                    fieldedInputs += 1;
                }
            }
        }
        return !(fieldedInputs === maxValue);
    };
}

export function generateSlugLink({ name, id }) {
    const _nameAndId = `${name} ${id}`;
    const slugLink = slug(_nameAndId);

    return slugLink;
}

export const getUrlSearchIds = search => {
    if (typeof search === 'string') {
        const [params, idsStrings] = search.split('id=');
        return idsStrings;
    }
};

export function getId(url) {
    if (typeof url === 'string') {
        return url
            .split('-')
            .slice(-1)
            .join('');
    }
}

export const convertSpaceToDash = string => {
    if (typeof string === 'string') {
        return string.split(' ').join('-');
    }
};

export const roundNumber = (value, range) => {
    if (value && Number.isInteger(range)) {
        if (Number.isInteger(value)) return value;
        else return parseInt(value.toFixed(range), 10).toString();
    } else {
        return value;
    }
};

export function displayTimeStamp(when, when_type) {
    let stringTime = 'All Time';
    const leaderboardTime = moment(when * 1000);
    const currentTime = moment();

    switch (when_type) {
        case 0: {
            const isThisDay = leaderboardTime.day() === currentTime.day();
            stringTime = isThisDay ? 'Today' : leaderboardTime.format('d MMM yyyy');
            break;
        }
        case 1: {
            const isThisYear =
                leaderboardTime.year() === currentTime.year() && leaderboardTime.month() === currentTime.month();
            stringTime = isThisYear ? 'This month' : leaderboardTime.format('d MMM yyyy');
            break;
        }
        case 2: {
            const isThisYear = leaderboardTime.year() === currentTime.year();
            stringTime = isThisYear ? 'This year' : leaderboardTime.format('d MMM yyyy');
            break;
        }
        default: {
            break;
        }
    }

    return stringTime;
}

export const displayTopLeaderboardLabel = ({ gym, workout }) => {
    let resultString = 'Across Tona';

    if (workout) {
        if (workout.hasOwnProperty('data')) {
            resultString = workout.data.title;
        } else {
            resultString = workout.title;
        }
    } else if (gym !== null && typeof gym === 'object') {
        if (path(gym, 'data') && !Array.isArray(gym.data) && path(gym, 'data', 'fullname')) {
            resultString = `${gym.data.fullname}`;
        }
    }

    return resultString;
};

export function displayTitleLeaderboard(city, country, gym) {
    let locationString = 'Global';
    if (city || country) {
        locationString = `${city || country}`;
    }

    if (gym !== null && typeof gym === 'object') {
        if (path(gym, 'data') && !Array.isArray(gym.data) && path(gym, 'data', 'fullname')) {
            locationString = `${gym.data.fullname}`;
        }
    }

    return locationString;
}

export const displayInfo = ({ when, when_type, city, country, gym, sex, age, bodyweight }) => {
    let infoString = '';
    infoString += `${displayTimeStamp(when, when_type)} \u2022 `;
    infoString += `${displayTitleLeaderboard(city, country, gym)} `;

    if (sex) {
        let gender = '';
        switch (sex) {
            case 0:
                gender = 'Female';
                break;
            case 1:
                gender = 'Male';
                break;
            default:
                break;
        }

        infoString += ` \u2022 ${gender} only`;
    }

    if (age) {
        infoString += ` \u2022 ${age} ${age === 1 ? 'year' : 'years'} old`;
    }

    if (bodyweight) {
        infoString += ` \u2022 ${bodyweight}`;
    }

    return infoString;
};

export function getQueryParam(locations, key = '') {
    if (key.length !== 0) {
        const queryurl = locations.substring(1);
        const queryObj = new URLSearchParams(queryurl);
        const expectedVal = queryObj.get(key);
        if (expectedVal) {
            return expectedVal;
        }
    } else {
        throw new Error('The key value is required');
    }
}

export const displayMetric = (type, data, userMetric) => {
    switch (type) {
        case 3:
            return userMetric ? lbsToKgs(data) : roundNumber(data, 1);
        case 5:
            return displayTime(data);
        default:
            return roundNumber(data, 1);
    }
};

export const displayActivityCardMetric = (data, userMetric, withoutLabel) => {
    const kgs = lbsToKgs(data);
    const lbs = roundNumber(data, 0);

    if (withoutLabel) {
        return userMetric ? kgs : lbs;
    } else {
        return userMetric ? `${kgs} kg` : `${lbs} ${lbs === 1 ? 'lb' : 'lbs'}`;
    }
};

export const displayActivityCardMetricValue = (data, userMetric, withoutLabel) => {
    const kgs = lbsToKgs(data);
    const lbs = roundNumber(data, 0);

    if (withoutLabel) return userMetric ? kgs : lbs;

    return userMetric ? { kgs } : { lbs };
};

export const lbsToKgs = lbs => {
    return roundNumber(lbs / 2.2046, 0);
};

export const getNumberOrder = number => {
    if (number !== null) {
        let lastDigit = parseInt(
            number
                .toString()
                .split('')
                .pop(),
        );

        switch (lastDigit) {
            case 1:
                return `${number}st`;
            case 2:
                return `${number}nd`;
            case 3:
                return `${number}rd`;
            default:
                return `${number}th`;
        }
    } else {
        return '1st';
    }
};

export const swap = (array, indexA, indexB) => {
    if (array.length > indexA && array.length > indexB) {
        let temp = array[indexA];
        array[indexA] = array[indexB];
        array[indexB] = temp;

        return array;
    }

    return array;
};

export async function generateQRCodeLink(
    { gym, workout, age, bodyweight, city, country, sex, when, when_type } = {},
    id,
    type,
) {
    // workout qr code link
    if (workout) {
        const _branchConfig = {
            type: 'Workout',
            id: Number(workout.id),
        };

        let _link = await createBranchIOLink(_branchConfig);
        return Promise.resolve(_link);
    }

    // user qr code link
    if (gym || age || bodyweight || city || country || sex || when || when_type) {
        const _branchConfig = {
            type,
            id: Number(getId(id)),
        };

        let _link = await createBranchIOLink(_branchConfig);
        return Promise.resolve(_link);
    }

    // global qr code link
    const _defaultBranchConfig = {
        type: 'Global',
    };

    let _link = await createBranchIOLink(_defaultBranchConfig);
    return Promise.resolve(_link);
}

export const copyObject = obj => {
    return JSON.parse(JSON.stringify(obj));
};

// workout plan
export const isWorkoutEmpty = rounds => {
    if (rounds.length === 1 && rounds[0].length === 0) {
        return true;
    }

    return false;
};

export const getRoundsLength = rounds => {
    return isWorkoutEmpty(rounds) ? 0 : rounds.length;
};

export const getTotalDistance = rounds => {
    if (isWorkoutEmpty(rounds)) return 0;

    let distance = 0;
    rounds.forEach(round => {
        round.forEach(exercise => {
            if (exercise.distance && exercise.distance !== 'N/A') distance += Number(exercise.distance);
        });
    });

    return distance;
};

export const getTotalWeight = rounds => {
    if (isWorkoutEmpty(rounds)) return 0;

    let weight = 0;
    rounds.forEach(round => {
        round.forEach(exercise => {
            if (typeof exercise.kgs === 'string' && exercise.kgs !== 'N/A') weight += Number(exercise.kgs);
        });
    });

    return weight;
};

export const getTotalReps = rounds => {
    if (isWorkoutEmpty(rounds)) return 0;

    let reps = 0;
    rounds.forEach(round => {
        round.forEach(exercise => {
            if (exercise.reps !== 'N/A') reps += Number(exercise.reps);
        });
    });

    return reps;
};

export const getTotalCalories = rounds => {
    if (isWorkoutEmpty(rounds)) return 0;

    let calories = 0;
    rounds.forEach(round => {
        round.forEach(exercise => {
            calories += Number(exercise.calories);
        });
    });

    return calories;
};

export const getTotalTime = rounds => {
    if (isWorkoutEmpty(rounds)) return '00:00:00';

    let seconds = 0;

    rounds.forEach(round => {
        round.forEach(exercise => {
            seconds += convertFormatToSeconds(exercise.time);
        });
    });

    return convertTimeToFormat(seconds);
};

export const convertTimeToFormat = seconds => {
    seconds = Number(seconds);

    let hours = addLeadingZero(Math.floor(seconds / HOUR));
    seconds -= hours * HOUR;
    let minutes = addLeadingZero(Math.floor(seconds / MINUTE));
    seconds -= minutes * MINUTE;
    seconds = addLeadingZero(seconds);

    return `${hours}:${minutes}:${seconds}`;
};

export const getTimeUnits = seconds => {
    seconds = Number(seconds);

    let hours = addLeadingZero(Math.floor(seconds / HOUR));
    seconds -= hours * HOUR;
    let minutes = addLeadingZero(Math.floor(seconds / MINUTE));
    seconds -= minutes * MINUTE;
    seconds = addLeadingZero(seconds);

    return {
        hours,
        minutes,
        seconds,
    };
};

// 00:00:00 to seconds
export const convertFormatToSeconds = format => {
    let time = format.split(':');
    let seconds = Number(time[2]); // seconds
    seconds += Number(time[1]) * 60; // minutes
    seconds += Number(time[0]) * 60 * 60; // hours

    return seconds;
};

export const convertFormatToHours = format => {
    const secondsValue = convertFormatToSeconds(format);
    return secondsValue / HOUR;
};

const addLeadingZero = str => {
    return str.toString().length < 2 ? `0${str}` : str;
};

export const getWorkoutSummary = rounds => {
    let roundsNumber = getRoundsLength(rounds);
    let distance = getTotalDistance(rounds);
    let weight = getTotalWeight(rounds);
    let reps = getTotalReps(rounds);
    let calories = getTotalCalories(rounds);
    let time = getTotalTime(rounds);

    return {
        roundsNumber,
        distance,
        weight,
        reps,
        calories,
        time,
    };
};

export const getWorkoutType = type => {
    switch (type) {
        case 0:
            return 'Other';
        case 1:
            return 'Aerobics';
        case 2:
            return 'Animal Movement';
        case 3:
            return 'Barre';
        case 4:
            return 'Bodyweight';
        case 5:
            return 'Bootcamp';
        case 6:
            return 'Boxing';
        case 7:
            return 'Calisthenics';
        case 8:
            return 'Circuit Training';
        case 9:
            return 'Conditioning';
        case 10:
            return 'Core';
        case 11:
            return 'Crossfit';
        case 12:
            return 'HIIT';
        case 13:
            return 'Kettlebell';
        case 14:
            return 'Martial Arts';
        case 15:
            return 'Military';
        case 16:
            return 'Pilates';
        case 17:
            return 'Spinning';
        case 18:
            return 'Stretching';
        case 19:
            return 'Swimming';
        case 20:
            return 'Tabata';
        case 21:
            return 'Water Aerobics';
        case 22:
            return 'Weight Training';
        case 23:
            return 'Yoga';
        case 24:
            return 'Cardio';
        case 25:
            return 'Walking';
        case 26:
            return 'Running';
        case 27:
            return 'Cycling';
        case 28:
            return 'Strongman';
        case 29:
            return 'TRX';
        case 30:
            return 'Rowing';
        case 31:
            return 'Strength Training';
        case 32:
            return 'Gym';
        default:
            return;
    }
};

export const getCaloriesMultiplier = type => {
    switch (type) {
        case 0:
            return 1;
        case 1:
            return 2;
        case 2:
            return 2;
        case 3:
            return 2;
        case 4:
            return 3;
        case 5:
            return 3;
        case 6:
            return 3;
        case 7:
            return 2.5;
        case 8:
            return 3;
        case 9:
            return 3;
        case 10:
            return 3;
        case 11:
            return 3;
        case 12:
            return 3;
        case 13:
            return 2.5;
        case 14:
            return 2;
        case 15:
            return 3;
        case 16:
            return 2;
        case 17:
            return 1;
        case 18:
            return 1;
        case 19:
            return 1;
        case 20:
            return 3;
        case 21:
            return 2;
        case 22:
            return 2;
        case 23:
            return 1;
        case 24:
            return 1;
        case 25:
            return 1;
        case 26:
            return 1;
        case 27:
            return 1;
        case 28:
            return 2.5;
        case 29:
            return 2.5;
        case 30:
            return 1;
        case 31:
            return 2;
        case 32:
            return 1;
        default:
            return 1;
    }
};

export const calculateTotalCalories = ({ time, MET_value, workoutType, bodyweight }) => {
    let caloriesMultiplier = getCaloriesMultiplier(workoutType);
    let kgWeight = lbsToKgs(bodyweight);
    let duration = convertFormatToSeconds(time) / 60; // in munutes

    return roundNumber((duration * (MET_value * 3.5 * kgWeight * caloriesMultiplier)) / 200, 1);
};

export const truncateLastName = name => {
    if (name.length === 0) return '';

    const words = name.split(' ');

    if (words.length === 1) return words[0];
    return `${words[0]} ${words[1][0]}.`;
};

export const selectInputContentOnFocus = ({ target }) => {
    target.select();
};

export const calculateSpeed = (time, distance) => {
    // kms / h
    return distance / time;
};

export const calculateDistance = (time, speed) => {
    // kms
    return time * speed;
};

export const truncateThousands = number => {
    if (typeof number === 'number') if (number >= 1000) return `${(number / 1000).toFixed(1)}k`;

    return number;
};

export const areObjectsEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);



// WEBPACK FOOTER //
// ./src/Utils/index.js